var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "198.127px",
    height: "198.128px",
    viewBox: "0 0 198.127 198.128",
    enableBackground: "new 0 0 198.127 198.128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1FD5B9",
    d: "M154.69,65.201l-46.474,55.856v31.583c0,2.619-1.525,4.136-4.145,4.136h-9.928 c-2.757,0-4.136-1.517-4.136-4.136v-31.312L43.53,65.201c-2.206-2.627-1.107-4.962,2.343-4.962h12.966 c2.067,0,3.717,0.681,4.962,2.61l35.719,44.273l35.726-44.273c1.24-1.93,2.895-2.61,4.963-2.61h12.005 C155.66,60.239,156.758,62.574,154.69,65.201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1FD5B9",
    d: "M88.549,64.094v-6.462c0-5.141,2.903-7.975,7.979-7.975h6.722c5.081,0,7.979,2.833,7.979,7.975v6.462 c0,5.011-2.898,7.983-7.979,7.983h-6.722C91.452,72.077,88.549,69.105,88.549,64.094"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1FD5B9",
    d: "M99.073,6.414c-51.094,0-92.662,41.563-92.662,92.651c0,51.086,41.568,92.651,92.662,92.651 c51.081,0,92.642-41.564,92.642-92.651C191.715,47.976,150.154,6.414,99.073,6.414z M99.073,186.315 c-48.118,0-87.266-39.141-87.266-87.25c0-48.112,39.148-87.254,87.266-87.254c48.105,0,87.241,39.142,87.241,87.254 C186.314,147.174,147.179,186.315,99.073,186.315z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.295ea12f842144b2ca7ea8c27ff388cf.svg";
export { ForwardRef as ReactComponent };